/** Derive active/inactive from subscription end date (same rule as admin account list). */
export function isSubscriptionActive(subscriptionEndDate: string | Date | null | undefined): boolean {
  if (!subscriptionEndDate) {
    return false;
  }
  const end = new Date(subscriptionEndDate);
  if (Number.isNaN(end.getTime())) {
    return false;
  }
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  end.setHours(0, 0, 0, 0);
  return end >= today;
}

export function formatSubscriptionDate(subscriptionEndDate: string | Date | null | undefined): string {
  if (!subscriptionEndDate) {
    return '—';
  }
  const d = new Date(subscriptionEndDate);
  if (Number.isNaN(d.getTime())) {
    return '—';
  }
  return d.toLocaleDateString(undefined, { month: '2-digit', day: '2-digit', year: 'numeric', timeZone: 'UTC' });
}
